import { Directive } from '@angular/core';

@Directive({
  selector: '[appWindowClose]'
})
export class WindowCloseDirective {
  // 子画面Windowのリスト
  public static winList: any[] = new Array<any>();
  // 移転フラグ
  public static itenFlg: boolean = false;
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/utility/window-close.directive.ts